// Generated by purs version 0.11.7
"use strict";
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./output/Data.NaturalTransformation/index.js
// module id = 303
// module chunks = 0